import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { useTranslation } from 'react-i18next';
import { message, Switch, Select, Form, Input } from 'antd';
import getUser from '../../hooks/getUser';
import useFetchOrganizations from '../../hooks/fetchOrganizations';
import { app } from '../../config';
// import  from '../../hooks/fetchRoles';
// import { getTokenfromUserObj } from '../utils/getTokenfromObj';
const { TextArea } = Input;
import InputMask from 'react-input-mask';
import useFetchRoles from '../../hooks/fetchRoles';
import { getTokenfromUserObj } from '../../utils/getTokenfromObj';

const Profileedit = () => {
  const { t } = useTranslation(['common']);
  const [uploadObj, setUploadObj] = useState({});
  const [phoneNumber, setPhoneNumber] = useState("");
  const token = getTokenfromUserObj();
  const navigate = useNavigate();
  // let userId = JSON.parse(localStorage.getItem('getUserId'));
  let user = JSON.parse(localStorage.getItem('user'));
  let res = getUser(user.userId);
  let userObj = res.response ? res.response.data : null;
  console.log(userObj);
  const r = useFetchRoles();
  console.log(r);
  const roles = r.response ? r.response.data : [];
  console.log(roles);
  const o = useFetchOrganizations();
  const orgs = o.response ? o.response.data : [];
  console.log(orgs);

  const uploadData = async (uploadObj) => {
    console.log('Function Running');
    try {
      const res = await axios.post(`${app.URL}/user/updateuser/${userObj.userId}`, uploadObj, { headers: { auth: token } });
      console.log('🚀 ~ file: EditOrg.js:49 ~ uploadData ~ res', res);
      if (res.status == 200) {
         const storedData = localStorage.getItem('user');
        
                if (storedData) {
                  const dataObject = JSON.parse(storedData);
                  dataObject.name = uploadObj.name; // Change 'specificKey' to your actual key
        
                  localStorage.setItem('user', JSON.stringify(dataObject));
                  // navigate('/organization/dashboard');
                  // window.location.reload();
                }
        navigate('/dashboard/view');
                message.success("Profile Updated Successfully.");
        // message.success(res?.data?.message ??"Profile updated successfully")
      }
    }
    catch(e){
      console.log(e)
      message.error( "Error occured")

    }
  }
  const onFinish = (values) => {
    console.log('Success:', values);
    const payload =
    {
      name: values.name ? values.name : userObj.name,
      // email:values.email?values.email:userObj.email,
      Password: values.password ? values.password : null,
      phone: values.phone ? values.phone : userObj.phone,
      roleId: values.roleId ? values.roleId : userObj.roleId,
      organizationId: values.organizationId ? values.organizationId : userObj.organizationId,
      isActive: values.isActive === true ? 1 : 0,
      updatedByUserId: user.userId,
    };
    setUploadObj(payload)
    if (Object.keys(payload).length > 0) {
      uploadData(payload);
    }
    
  };

  // const onFinishFinal = () => {
  //   console.log("first2",uploadObj)

  //   if (Object.keys(uploadObj).length > 0) {
  //   uploadData(uploadObj);
  //   }
  // }
  console.log(uploadObj);
  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };

  return (
    <div class='col-lg-9 mt-4 '>
      <div class='card'>
        <div class='card-body p-5'>
          <h2 class='text-center mb-5 mt-3 fw-bold fs-5'> {t('Update Profile')} </h2>
          <div class='col-lg-10 '>
            {res.response ? (
              <Form
                name='basic'
                labelCol={{
                  span: 8,
                }}
                wrapperCol={{
                  span: 25,
                }}
                style={{
                  maxWidth: 600,
                }}
                initialValues={{
                  remember: true,
                  ['name']: userObj.name,
                  ['email']: userObj.email,
                  ['phone']: userObj.phone,
                  ['roleId']: userObj.roleId,
                  ['organizationId']: userObj.organizationId,
                  ['isActive']: userObj.isActive === 1 ? true : false,
                }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete='off'
              >
                <Form.Item
                  colon={false}
                  label='Name'
                  name='name'
                  defaultValue='1'
                  rules={[
                    {
                      required: true,
                      message: 'Please input your name!',
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Email'
                  name='email'
                  rules={[
                    {
                      required: true,
                      type: 'email',
                      message: 'Please input your email!',
                    },
                  ]}
                >
                  <Input disabled={true} />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Password'
                  name='password'
                  rules={[
                    {
                      required: false,
                      message: 'Please input Password!',
                    },
                  ]}
                >
                  <Input.Password />
                </Form.Item>
                <Form.Item
                  colon={false}
                  label='Phone'
                  name='phone'
                  rules={[
                    {
                      required: true,
                      message: 'Please input Phone!',
                    },
                  ]}
                >
                  <InputMask mask='(999) 999-9999' onChange={(event)=>{
                    console.log(event.target.value)
                  }}>
                    {(inputProps) => <Input {...inputProps} placeholder='Mobile' />}
                    {/* <Input /> */}
                  </InputMask>
                  {/* <Input /> */}
                </Form.Item>
                <Form.Item label='Active' colon={false} valuePropName='checked' name='isActive'>
                  <Switch />
                </Form.Item>
                {/* Select box for Role */}
                <Form.Item
                  colon={false}
                  label='Role'
                  name='roleId'
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    style={{
                      width: 120,
                    }}
                    placeholder='Select'
                  >
                    {roles.map((role) => {
                      return (
                        <Option key={role.roleId} value={role.roleId}>
                          {role.name}
                        </Option>
                      );
                    })}
                  </Select>
                </Form.Item>
                {/* Select box for Organization */}
                <Form.Item
                  colon={false}
                  label='Organization'
                  name='organizationId'
                  rules={[
                    {
                      required: true,
                    },
                  ]}
                >
                  <Select
                    style={{
                      width: 160,
                    }}
                    placeholder='Select'
                  >
                    {orgs
                      ? orgs.map((org) => {
                          return (
                            <Option key={org.organizationId} value={org.organizationId}>
                              {org.organizationName}
                            </Option>
                          );
                        })
                      : ' '}
                  </Select>
                </Form.Item>
                {/* Outlet Name */}
                {/* <Form.Item
              label='Outlet Name'
              name='outletName'
              rules={[
                {
                  required: false,
                  message: 'Please input your username!',
                },
              ]}
            >
              <Input />
            </Form.Item> */}
                {/* Select box for organization */}
                {/* <Form.Item
              label='Address'
              name='address'
              rules={[
                {
                  required: false,
                  message: 'Please input your address!',
                },
              ]}
            >
              <Input />
            </Form.Item> */}
                {/* Organization */}
                {/* <Form.Item
              label='Organization'
              name='organizationId'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  width: 120,
                }}
              >
                {cities.map((city) => {
                  return (
                    <Option key={city.cityId} value={city.cityId}>
                      {city.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
                {/* State */}
                {/* <Form.Item
              label='State'
              name='state'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  width: 120,
                }}
              >
                {states.map((state) => {
                  return (
                    <Option key={state.stateId} value={state.stateId}>
                      {state.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item> */}
                {/* Country */}
                {/* <Form.Item
              label='Country'
              name='country'
              rules={[
                {
                  required: true,
                },
              ]}
            >
              <Select
                listHeight={250}
                listItemHeight={500}
                style={{
                  width: 120,
                }}
              >
                 {countries.map((country) => {
                  return (
                    <Option key={country.countryId} value={country.countryId}>
                      {country.name}
                    </Option>
                  );
                })}
              </Select>
            </Form.Item>
            <Form.Item
              label='Longitude'
              name='longitude'
              rules={[
                {
                  required: false,
                  message: 'Please input your address!',
                },
              ]}
            >
              <Input />
            </Form.Item>
            <Form.Item
              label='Latitude'
              name='latitude'
              rules={[
                {
                  required: false,
                  message: 'Please input your address!',
                },
              ]}
            >
              <Input />
            </Form.Item> */}

                {/* <Form.Item
              label='Description'
              name='description'
              rules={[
                {
                  message: 'Please input your password!',
                },
              ]}
            >
              <TextArea rows={4} />
            </Form.Item> */}

                <Form.Item
                  wrapperCol={{
                    offset: 8,
                    span: 16,
                  }}
                >
                  <button type='primary' class='btn btn-primary button' htmlType='submit'>
                    Submit
                  </button>
                </Form.Item>
              </Form>
            ) : (
              ' '
            )}
          </div>
          {/* 
              <form>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t("Id")}
                  </label>
                  <input type='text' name='id' disabled defaultValue={orgObj ? orgObj.organizationId : ' '} id='form3Example1cg' class='form-control form-control-lg' />
                </div>
                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example1cg'>
                    {t("Name")}
                  </label>
                  <input type='text' name='organization_name' id='form3Example1cg' defaultValue={orgObj ? orgObj.organizationName : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>

                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example3cg'>
                    {t("Email")}
                  </label>
                  <input type='email' name='email' id='form3Example3cg' defaultValue={orgObj ? orgObj.email : ' '} class='form-control form-control-lg' onChange={handleChange} />
                </div>

                <div class='form-outline mb-4'>
                  <label class='form-label' for='form3Example3cg'>
                    {t("Description")}
                  </label>
                  <input type='test' name='description' id='form3Example3cg' class='form-control form-control-lg' defaultValue={orgObj ? orgObj.description : ' '} onChange={handleChange} />
                </div>
                <div class='form-check'>
                  <input class='form-check-input' name='is_active' type='checkbox' defaultChecked={checked}  id='flexCheckDefault' onChange={handleCheckChange} />
                  <label class='form-check-label' for='flexCheckDefault'>
             {t("Active")}
                  </label>
                </div>
                <div class='d-flex justify-content-center'>
                  <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
                    {t("Edit")}
                  </button>
                </div>
              </form> */}
        </div>
      </div>
      {/*   </div>
      </div>
    </div> */}
      {/* </div> */}
      {/* </section> */}
    </div>

    /* <section class='vh-100 bg-image mt-5' style={{}}>
        <div class='mask d-flex align-items-center h-100 gradient-custom-3'>
          <div class='container h-100'>
            <div class='row d-flex justify-content-center align-items-center h-100'>
              <div class='col-12 col-md-9 col-lg-7 col-xl-6'>
                <div class='card'>
                  <div class='card-body p-5'>
                    <h2 class='text-uppercase text-center mb-5 fw-bold fs-5'>{t("Edit Organization")}</h2>

                    <form>
                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example1cg'>
                          {t("Id")}
                        </label>
                        <input type='text' name='id' disabled defaultValue={orgObj ? orgObj.organization_id : ' '} id='form3Example1cg' class='form-control form-control-lg' />
                      </div>
                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example1cg'>
                          {t("Name")}
                        </label>
                        <input type='text' name='organization_name' id='form3Example1cg' defaultValue={orgObj ? orgObj.organization_name : ' '} class='form-control form-control-lg' onChange={handleChange} />
                      </div>

                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example3cg'>
                          {t("Email")}
                        </label>
                        <input type='email' name='email' id='form3Example3cg' defaultValue={orgObj ? orgObj.email : ' '} class='form-control form-control-lg' onChange={handleChange} />
                      </div>

                      <div class='form-outline mb-4'>
                        <label class='form-label' for='form3Example3cg'>
                          {t("Description")}
                        </label>
                        <input type='test' name='description' id='form3Example3cg' class='form-control form-control-lg' defaultValue={orgObj ? orgObj.description : ' '} onChange={handleChange} />
                      </div>
                      <div class='form-check'>
                        <input class='form-check-input' name='is_active' type='checkbox' defaultChecked={checked}  id='flexCheckDefault' onChange={handleCheckChange} />
                        <label class='form-check-label' for='flexCheckDefault'>
                   {t("Active")}
                        </label>
                      </div>
                      <div class='d-flex justify-content-center'>
                        <button type='button' class='btn btn-outline-primary btn-block btn-lg gradient-custom-2 text-body' onClick={handleSubmit}>
                          {t("Edit")}
                        </button>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section> */
  );
};

export default Profileedit;
